var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8917 14.6955L9.36243 8.16688L15.892 1.63664C16.1699 1.35874 16.1699 0.907898 15.8917 0.630311C15.6132 0.351776 15.163 0.351776 14.8844 0.630311L8.35515 7.1596L1.82491 0.629995C1.54827 0.352092 1.0968 0.352092 0.818897 0.630627C0.540994 0.907898 0.540678 1.35905 0.818581 1.63696L7.34787 8.16688L0.818898 14.6952C0.540679 14.9741 0.54068 15.4243 0.818898 15.7031C0.957375 15.8416 1.1398 15.9121 1.32159 15.9124C1.50369 15.9124 1.68643 15.8422 1.82491 15.7031L8.35515 9.17416L14.8841 15.7031C15.0236 15.8419 15.2066 15.9124 15.3887 15.9124C15.5699 15.9121 15.7529 15.8416 15.892 15.7031C16.1696 15.4249 16.1703 14.9741 15.8917 14.6955Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.53d6b0271156b0f24efcfa0a2ec88e45.svg";
export { ForwardRef as ReactComponent };